/**
 * Sliders component.
 */
import SliderControls from '@components/sections/sliders/ui/controls/sliderControls';
import SliderList from '@components/sections/sliders/ui/list/sliderList';
import useSliders from '@components/sections/sliders/lib/useSliders';
import { memo } from 'react';

/**
 * Sliders component that displays the main slider section.
 *
 * @returns {JSX.Element} The sliders container with background and list components
 */
function Sliders() {
  // ------------------------------------------------------------
  // Initialization
  // ------------------------------------------------------------

  const { display, callbacks, props } = useSliders();

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------

  return display ? (
    <>
      <SliderControls
        arrows={callbacks.arrows}
        controls={callbacks.controls}
        dots={props.paginationDots}
      />
      <SliderList {...props.list} {...callbacks.list} />
    </>
  ) : null;
}

export default memo(Sliders);
